import { CheckCircle, TrendingUp, Clock, FileText, X } from "lucide-react";

// Database status mapping to UI display
export const statusDisplayMap = {
  'draft': 'Draft',
  'pending': 'Pending response',
  'accepted': 'Accepted',
  'rejected': 'Rejected',
  'overdue': 'Overdue'
} as const;

export const statusOptions = ["draft", "pending", "accepted", "rejected"];

export const getStatusColor = (status: string) => {
  switch (status) {
    case "draft": return "bg-gray-100 text-gray-800";
    case "accepted": return "bg-green-100 text-green-800";
    case "pending": return "bg-yellow-100 text-yellow-800";
    case "overdue": return "bg-red-100 text-red-800";
    case "rejected": return "bg-red-100 text-red-800";
    default: return "bg-gray-100 text-gray-800";
  }
};

export const getStatusIcon = (status: string) => {
  switch (status) {
    case "draft": return FileText;
    case "accepted": return CheckCircle;
    case "pending": return TrendingUp;
    case "overdue": return Clock;
    case "rejected": return X;
    default: return Clock;
  }
};

// Utility function to determine proposal status based on response deadline
export const getProposalStatus = (proposal: { status?: string; sent_date?: string; response_deadline?: string }) => {
  // If no sent_date, it's always a draft regardless of database status
  if (!proposal.sent_date) {
    return 'draft';
  }
  
  // If it's accepted or rejected, keep that status
  if (proposal.status === 'accepted' || proposal.status === 'rejected') {
    return proposal.status;
  }
  
  // If no response deadline, keep as pending
  if (!proposal.response_deadline) {
    return 'pending';
  }
  
  // Check if deadline has passed
  const deadline = new Date(proposal.response_deadline);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day for fair comparison
  deadline.setHours(0, 0, 0, 0);
  
  if (deadline < today) {
    return 'overdue';
  }
  
  return 'pending';
};

// Type definitions
export type ProposalStatus = keyof typeof statusDisplayMap;